import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { NewFeature } from "@aika/types";

export const FeaturesContext = createContext<NewFeature[]>([]);

export const FeaturesProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [features, setFeatures] = useState<NewFeature[]>([]);

  useEffect(() => {
    axios
      .get<NewFeature[]>("/api/new-features")
      .then(({ data }) => setFeatures(data));
  }, []);

  return (
    <FeaturesContext.Provider value={features}>
      {children}
    </FeaturesContext.Provider>
  );
};

export const useFeatures = (): NewFeature[] => useContext(FeaturesContext);
